/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */

const VCPU_PER_HOUR = 0.205;
const ONE_vCPU = 1024;
const RAM_GB_PER_HOUR = 0.0225;
const ONE_GiB_RAM = 1024;
const SSD_GB_PER_HOUR_ABOVE_21 = 0.00056;

export const creditsPerHour = (
  vcpus: number,
  memoryMb: number,
  storageGb: number,
): number => {
  const vcpu_contribution = VCPU_PER_HOUR * (vcpus / ONE_vCPU);
  const ram_contribution = RAM_GB_PER_HOUR * (memoryMb / ONE_GiB_RAM);
  const ssd_contribution =
    SSD_GB_PER_HOUR_ABOVE_21 * Math.max(0, storageGb - 21);

  return vcpu_contribution + ram_contribution + ssd_contribution;
};
